import FootballState from "../../../../../sports/football/state/football-state";
import { getTouchbackYardline } from "../../../../../sports/football/utils/context-utils";
import { FragmentSerializer } from "./FragmentSerializer";

export class FairCatchFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.FairCatch;
    }

    getRawFragment(play, serializationContext, fairCatch) {
        const { gameConfig } = serializationContext.gameContext;
        const { autoFairCatchTb } = gameConfig.general;

        const { kickedBy, puntedBy } =
            play.getPreceedingFragment(fairCatch, [
                FootballState.Punt,
                FootballState.CflKick,
                FootballState.Kick
            ]) || {};
        const { kickedTo } =
            play.getPreceedingFragment(fairCatch, FootballState.KickOff) || {};

        const kickingPlayer = kickedBy || puntedBy;
        const kickSpot = puntedBy ? null : kickedTo;

        const caughtBy = fairCatch.getPlayers()[0];
        const receivingTeam = this.resolveTeam(serializationContext, caughtBy);

        const teamTbYardline = getTouchbackYardline(
            true,
            receivingTeam === "H",
            gameConfig
        );

        const isFairCatchTb =
            (kickSpot || kickSpot === 0) &&
            autoFairCatchTb &&
            (receivingTeam === "H"
                ? kickSpot < teamTbYardline
                : kickSpot > teamTbYardline);

        let updatedSpot = "";

        if (isFairCatchTb) {
            const possession = this.resolveOpponent(
                serializationContext,
                kickingPlayer
            );
            const spot = this.resolveFormattedFieldPosition(
                serializationContext,
                teamTbYardline
            );
            updatedSpot = ` SPOT:${possession},${spot},Y`;
        }

        const uniform = this.resolveUniform(serializationContext, caughtBy);

        const rawPlay = `FC:${uniform}${updatedSpot}`;
        return rawPlay;
    }
}
